import { Any } from 'google-protobuf/google/protobuf/any_pb';
import {
    RealTimeChatMessage,
    AudioFormatContent,
    AudioChunkContent,
    RealTimeChatMessageType,
    RealTimeChatMessageOperationType,
    AudioResponseContent,
    AudioSpeechRecognitionResultContent,
    TranslationRequestContent,
    Text2SpeechRequestContent,
} from  './generated/RealTimeChatService_pb'
// import { RealTimeChatServiceClient } from './generated/RealTimeChatServiceServiceClientPb.ts';
import * as pcm from './utils/pcm_utils.ts';

var ws = null; //实现WebSocket
var record = null; //多媒体对象，用来处理音频
var command;//最新语音汉字
var lastCommandUpdate;//最新语音汉字的时间
var numOfAudioPacketsSent = 0;
var audioFormat = 'N/A';
var audioInput,scriptNode,audioFormatRtcProto;
const targetPcmFormat = {
    channels: 1,
    sampleRate: 16000,
    bitDepth: 16,
};
function init(rec) {
    record = rec;
}

function selectAvatarFile(cb) {
    const inputElem = document.createElement('input');
    inputElem.type = 'file';
    inputElem.accept = 'image/*';
    inputElem.onchange = () => {
        cb(inputElem.files[0]);
    };
    inputElem.click();
}
//录音对象
var Recorder = function(stream) {
    var sampleBits = 16; //输出采样数位 8, 16
    var sampleRate = 48000; //输出采样率
    var context = new AudioContext();
    var audioInput = context.createMediaStreamSource(stream);
    var recorder = context.createScriptProcessor(4096, 1, 1);
    var audioData = {
        size: 0, //录音文件长度
        buffer: [], //录音缓存
        inputSampleRate: 16000, //输入采样率
        inputSampleBits: 16, //输入采样数位 8, 16
        outputSampleRate: sampleRate, //输出采样数位
        oututSampleBits: sampleBits, //输出采样率
        clear: function() {
            this.buffer = [];
            this.size = 0;
        },
        input: function(data) {
            this.buffer.push(new Float32Array(data));
            this.size += data.length;
        },
        compress: function() { //合并压缩
            //合并
            var data = new Float32Array(this.size);
            var offset = 0;
            for (var i = 0; i < this.buffer.length; i++) {
                data.set(this.buffer[i], offset);
                offset += this.buffer[i].length;
            }
            //压缩
            var compression = parseInt(this.inputSampleRate / this.outputSampleRate);
            var length = data.length / compression;
            var result = new Float32Array(length);
            var index = 0,
                j = 0;
            while (index < length) {
                result[index] = data[j];
                j += compression;
                index++;
            }
            return result;
        },
        encodePCM: function() { //这里不对采集到的数据进行其他格式处理，如有需要均交给服务器端处理。
            var sampleRate = Math.min(this.inputSampleRate, this.outputSampleRate);
            var sampleBits = Math.min(this.inputSampleBits, this.oututSampleBits);
            var bytes = this.compress();
            var dataLength = bytes.length * (sampleBits / 8);
            var buffer = new ArrayBuffer(dataLength);
            var data = new DataView(buffer);
            var offset = 0;
            for (var i = 0; i < bytes.length; i++, offset += 2) {
                var s = Math.max(-1, Math.min(1, bytes[i]));
                data.setInt16(offset, s < 0 ? s * 0x8000 : s * 0x7FFF, true);
            }
            return new Blob([data]);
        }
    };

    var sendData = function(message) { //对以获取的数据进行处理(分包)

        if (message != null) {
            useWebSocket(message);
        }
        audioData.clear();//每次发送完成则清理掉旧数据
    };

    this.start = function() {
        audioInput.connect(recorder);
        recorder.connect(context.destination);
    }

    this.stop = function() {
        recorder.disconnect();
    }

    this.getBlob = function() {
        return audioData.encodePCM();
    }

    this.clear = function() {
        audioData.clear();
    }

    recorder.onaudioprocess = function(e) {
        // var inputBuffer = e.inputBuffer.getChannelData(0);
        var inputBuffer = e.inputBuffer;
        if(!audioFormatRtcProto){
            const rawAudioFormat = {
                float: true,
                channels: inputBuffer.numberOfChannels,
                sampleRate: inputBuffer.sampleRate,
                interleaved: false,
                bitDepth: inputBuffer.bitDepth,
            };
            audioFormat = JSON.stringify(rawAudioFormat);
            const audioFormatProto = new AudioFormatContent();
            audioFormatProto.setChannels(rawAudioFormat.channels);
            audioFormatProto.setBitdepth(rawAudioFormat.bitDepth);
            audioFormatProto.setSamplerate(rawAudioFormat.sampleRate);
            console.log(audioFormatProto);

            const messageProto = new RealTimeChatMessage();
            messageProto.setType(RealTimeChatMessageType.AUDIOFORMAT);
            messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
            const content = new Any();
            content.pack(audioFormatProto.serializeBinary(), 'RealTimeChat.AudioFormatContent');
            messageProto.setContent(content);

            console.log(messageProto);
            audioFormatRtcProto = messageProto;
        }
        const resampled = pcm.toArrayBuffer(inputBuffer, targetPcmFormat);
        const audioChunkProto = new AudioChunkContent();
        audioChunkProto.setData(new Uint8Array(resampled));
        const messageProto = new RealTimeChatMessage();
        messageProto.setType(RealTimeChatMessageType.AUDIOCHUNK);
        messageProto.setOperationtype(RealTimeChatMessageOperationType.INFORM);
        const content = new Any();
        content.pack(audioChunkProto.serializeBinary(), 'RealTimeChat.AudioChunkContent');
        messageProto.setContent(content);
        // console.log(messageProto)
        numOfAudioPacketsSent += 1;
        audioData.input(inputBuffer);
        sendData(messageProto);
    }
}
function handleSrResult(content) {
    const isIntermediate = content.getIsintermediate();
    const srResult = content.getText().trim();
    console.log(`srResult: (${isIntermediate}) ${srResult}`);
    if (!isIntermediate) {
        command = srResult;
    }
    window.localStorage.clear()
    window.localStorage.setItem('command',srResult);
    window.localStorage.setItem('lastCommandUpdate',lastCommandUpdate);
    lastCommandUpdate = new Date();
}
function reconnectedIfNeeded() {
    if (ws && (ws.readyState === WebSocket.OPEN || ws.readyState === WebSocket.CONNECTING)) {
        return;
    }
    try {
        ws?.close();
    } catch (e) {
        console.error(e);
    }
    ws = new WebSocket("wss://api.acme-ai.net/wsapi/rtc");
    bindWebSocketEventListeners()
}
function bindWebSocketEventListeners(){
    if (ws) {
       ws.onmessage = webSocketOnMessage;
       ws.onopen = webSocketOnOpen;
    }
}
function webSocketOnMessage(evt) {
    const blob = evt.data;
    const fileReader = new FileReader();
    fileReader.readAsArrayBuffer(blob);
    fileReader.onload = () => {
        const message = RealTimeChatMessage.deserializeBinary(new Uint8Array(fileReader.result));
        console.log(message.getType());
        if (message.getType() === RealTimeChatMessageType.AUDIORESPONSE) {
            console.log(message.getContent());
            // const content = message
            //     .getContent()
            //     .unpack(
            //         AudioResponseContent.deserializeBinary,
            //         'RealTimeChat.AudioResponseContent',
            //     ) as AudioResponseContent;

            // const text = content.getText();
            // console.log(`text: ${text}`);
            // self.audioPlayUrl = content.getAudiourl();
            // console.log(self.audioPlayUrl);
            // const audioTag = document.getElementById('audio_player') as HTMLAudioElement;
            // audioTag.play();
        } else if (message.getType() === RealTimeChatMessageType.AUDIOSPEECHRECOGNITIONRESULT) {
            const content = message
                .getContent()
                .unpack(
                    AudioSpeechRecognitionResultContent.deserializeBinary,
                    'RealTimeChat.AudioSpeechRecognitionResultContent',
                );
            console.log(content)
            handleSrResult(content);
        } else if (message.getType() === RealTimeChatMessageType.INTERRUPSIGNAL) {
            // self.audioPlayUrl = '';
        }
    };
}
function webSocketOnOpen() {
    useWebSocket(audioFormatRtcProto);
    console.log('audio format sent');
    console.log(audioFormatRtcProto);
}
/*
* WebSocket
*/
function useWebSocket(message) {
    // ws = new WebSocket("wss://10.0.0.10/wsapi/rtc");
    // ws.binaryType = 'arraybuffer'; //传输的是 ArrayBuffer 类型的数据
    reconnectedIfNeeded();
    // console.log(WebSocket.OPEN)
    // console.log(ws.readyState)
    if (ws && ws.readyState === WebSocket.OPEN) {
        // console.log(message.serializeBinary().buffer)
        // console.log(8)
        ws.send(message.serializeBinary().buffer);
    }
}
/*
* 开始对讲
*/
function info() {
    navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
    if (!navigator.getUserMedia) {
        alert('浏览器不支持音频输入');
    } else {
        navigator.getUserMedia({
                audio: true
            },
            function(stream) {
            // console.log(mediaStream)
                init(new Recorder(stream));
                console.log('开始对讲');
                console.log(new Recorder(stream))
                record.start();
                // useWebSocket();
            },
            function(error) {
                console.log(error);
                switch (error.message || error.name) {
                    case 'PERMISSION_DENIED':
                    case 'PermissionDeniedError':
                        console.info('用户拒绝提供信息。');
                        break;
                    case 'NOT_SUPPORTED_ERROR':
                    case 'NotSupportedError':
                        console.info('浏览器不支持硬件设备。');
                        break;
                    case 'MANDATORY_UNSATISFIED_ERROR':
                    case 'MandatoryUnsatisfiedError':
                        console.info('无法发现指定的硬件设备。');
                        break;
                    default:
                        console.info('无法打开麦克风。异常信息:' + (error.code || error.name));
                        break;
                }
            }
        )
    }
}
// info();
/*
* 关闭对讲
*/
 function end() {
    if (ws) {
        ws.close();
        record.stop();
        console.log('关闭对讲以及WebSocket');
    }
}

export default{
    info,
    command,//最新语音汉字
    handleSrResult,//最新语音汉字的时间
}